import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPcrIdSelector } from '../../../home/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getInitialAssessmentAirway } from '../selectors/getInitialAssessmentAirway.selectors'
import { IAssessmentsAirwayState } from '../store/airway.types'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { AirwayConstants } from '../store/airway.constants'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* saveInitialAssessmentAirway() {
  const initalAssessmentAirway: IAssessmentsAirwayState = yield select(getInitialAssessmentAirway)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated = {
      ...pcrDoc,
      prNabc: { ...pcrDoc.prNabc, ...initalAssessmentAirway.prNabc },
      prAirwayAssess: initalAssessmentAirway.prAirwayAssess,
      prAirwayVerificationAssess: initalAssessmentAirway.prAirwayVerificationAssess,
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveInitialAssessmentAirway() error: ${e}`))
    }
  }
}

export function* saveInitialAssessmentAirwaySaga() {
  yield takeLatest([AirwayConstants.SAVE_INITIAL_ASSESSMENT_AIRWAY], performWithMutexHOG, saveInitialAssessmentAirway)
}
